class Customer.Subtype extends Backbone.Model
  defaults:
    id: ''
    group: ''

class Customer.SubtypeCollection extends Backbone.Collection
  model: Customer.Subtype
  url: '/customer/ticket/available_types'
